import { ComponentProps } from "react";
import { Outlet } from "react-router-dom";
import styled from "@emotion/styled";
import { GraphSidebar } from "./GraphSidebar";

const Main = styled.main`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ExploreGraphLayout = styled((props: ComponentProps<"div">) => (
  <div {...props}>
    <Main>
      <Outlet />
      <GraphSidebar />
    </Main>
  </div>
))`
  display: flex;
  justify-content: center;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background.default};
`;
